import "../App.css"
import { AppNav } from "./AppNav";
import { AppPage } from "./AppPage"

export function AppMain() {

    return (
        <div id="appmain" className="AppMain">
            <AppNav/>
            <AppPage/>
        </div>
    );
}
